import CityPageTemplate from "../city-template/CityPageTemplate";
import { bakersfieldConfig } from "./data";

export default function BakersfieldPage() {
  return <CityPageTemplate config={bakersfieldConfig} />;
}